import { Component, Host, h, Element, Prop } from '@stencil/core';

export interface FaIcon extends HTMLFaIconElement {}

/**
 * <b>READ: If you have want to use a font awesome icon, use the standard method using
 * classnames instead of fa-icon. Those classes cannot pierce the shadow dom,
 * so when you want to use an icon inside another web component, that is where
 * `fa-icon` comes in.</b>
 *
 * Subset of font awesome icons for use inside shadow dom.
 *
 * This differs from aha-icon in that it loads only a subset of icons, namely
 * those we actually use. This helps with performance compared to aha-icon.
 */
@Component({
  tag: 'fa-icon',
  styleUrl: 'fa-icon.css',
  shadow: true,
})
export class FaIcon {
  @Element() host!: HTMLFaIconElement;
  /**
   * Icon to display in the fa-icon component.
   */
  @Prop() icon: string = '';
  render() {
    return (
      <Host>
        <i class={this.icon}></i>
      </Host>
    );
  }
}
